/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { TextField } from '@mui/material';
import {
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { toast } from 'react-toastify';


export const DatePicker = (props: any) => {
  const [open, setOpen] = useState(false)

  const { formState: { errors } } = props.formHook || { formState: { errors: {} } }

  const valueChange = (date: Dayjs | null) => {
    if (date?.toDate().setHours(0, 0, 0, 0) == props.minDate.setHours(0, 0, 0, 0) && props.label == "Coverage Start Date") {
      toast(<div>Need same day coverage? <br /><br /> Call 1-844-977-4959 to start coverage today.</div>, {
        type: 'info',
      });
      props.onChange(null, undefined);
      props.formHook?.setValue(props.name as string, null);
      return
    }

    const value = date?.toDate() || null;
    props.onChange(value, undefined);
    props.onSelect && props.onSelect();
    props.formHook?.setValue(props.name as string, value);
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <input
        hidden
        ref={props.setInputRef}
        value={props.value}
        onChange={() => { }}
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MuiDatePicker
          label={props.label}
          open={open}
          onClose={() => setOpen(false)}
          value={props.value || null}
          onChange={valueChange}
          disableOpenPicker
          disableHighlightToday
          minDate={props.minDate}
          maxDate={props.maxDate}
          PaperProps={{
            sx: {
              '[aria-current="date"]': {
                color: 'rgba(0,0,0,0.38)'
              }
            }
          }}
          PopperProps={{
            sx: {
              "& .MuiPaper-root": {
                borderRadius: "20px",
              }
            }
          }}
          renderInput={(params: any) => (
            <TextField
              fullWidth
              {...params}
              onClick={() => setOpen(true)}
              required
              helperText={errors[props.name || '']?.message}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'primary.main',
                  },
                },
                '& .MuiFormLabel-root': {
                  color: 'secondary.main'
                },
                '& .MuiFormLabel-asterisk': {
                  color: 'error.main'
                },
                zIndex: 0,
              }}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
}
